const cards = [
  {
    title: '社内相亲',
    tag: '恋爱',
    desc: '职场恋爱喜剧，假扮情侣的甜蜜拉锯战，从契约到真心的浪漫旅程。',
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20businessman%20and%20a%20charming%20woman%20in%20a%20modern%20office%20setting%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20soft%20lighting%2C%20romantic%20atmosphere%2C%20clean%20flat%20illustration%20style%20with%20subtle%20gradients%2C%20elegant%20composition&width=800&height=560&seq=card-01-2026&orientation=landscape',
    alt: '社内相亲 - 韩漫免费漫画推荐',
  },
  {
    title: '我独自升级',
    tag: '动作',
    desc: '从最弱猎人到最强觉醒者，热血逆袭爽漫，战斗场面燃爆全场。',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20action%20scene%20with%20a%20powerful%20warrior%20silhouette%20surrounded%20by%20energy%20auras%20and%20magical%20effects%2C%20dark%20background%20with%20coral%20accents%2C%20epic%20atmosphere%2C%20stylized%20flat%20illustration%20with%20dramatic%20lighting%2C%20cinematic%20composition&width=800&height=560&seq=card-02-2026&orientation=landscape',
    alt: '我独自升级 - 韩漫免费漫画推荐',
  },
  {
    title: '女神降临',
    tag: '校园',
    desc: '化妆逆袭的校园故事，颜值与真心的双重考验，青春成长治愈之作。',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20stylish%20young%20woman%20in%20a%20school%20setting%20with%20cherry%20blossoms%2C%20soft%20pastel%20coral%20and%20cream%20tones%2C%20gentle%20lighting%2C%20youthful%20romantic%20vibe%2C%20clean%20flat%20illustration%20style%20with%20delicate%20details&width=800&height=560&seq=card-03-2026&orientation=landscape',
    alt: '女神降临 - 韩漫免费漫画推荐',
  },
  {
    title: '全知读者视角',
    tag: '奇幻',
    desc: '小说变成现实，唯一知晓结局的读者在末世中展开生存冒险。',
    img: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20illustration%20showing%20a%20mysterious%20figure%20holding%20a%20glowing%20book%20in%20a%20surreal%20apocalyptic%20landscape%2C%20warm%20amber%20and%20coral%20highlights%2C%20atmospheric%20lighting%2C%20stylized%20flat%20illustration%20with%20mystical%20vibe&width=800&height=560&seq=card-04-2026&orientation=landscape',
    alt: '全知读者视角 - 韩漫免费漫画推荐',
  },
  {
    title: '恶役只有死亡结局',
    tag: '悬疑',
    desc: '穿越成游戏反派，在死亡循环中寻找破局之路，高智商剧情反转不断。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20style%20illustration%20of%20a%20noblewoman%20in%20a%20dark%20palace%20corridor%20with%20dramatic%20shadows%2C%20coral%20and%20cream%20accent%20colors%2C%20suspenseful%20atmosphere%2C%20elegant%20flat%20illustration%20with%20gothic%20undertones&width=800&height=560&seq=card-05-2026&orientation=landscape',
    alt: '恶役只有死亡结局 - 韩漫免费漫画推荐',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精选推荐
          </h2>
          <a
            href="#index"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors duration-300 cursor-pointer data-product-shop"
              data-product-shop="true"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}